export const MENU_OPEN = 'MENU_OPEN';
export const MENU_CLOSE = 'MENU_CLOSE';
export const SHOW_HEADER = 'SHOW_HEADER';
export const HIDE_HEADER = 'HIDE_HEADER';
export const SHOW_FOOTER = 'SHOW_FOOTER';
export const HIDE_FOOTER = 'HIDE_FOOTER';
export const SHOW_GLOBAL_TRACKER_MODAL = 'SHOW_GLOBAL_TRACKER_MODAL';
export const HIDE_MODALS = 'HIDE_MODALS';
export const SHOW_MILESTONE_MODAL = 'SHOW_MILESTONE_MODAL';
export const SHOW_DIET_DIAPER_MODAL = 'SHOW_DIET_DIAPER_MODAL';
export const SHOW_GROWTH_MODAL = 'SHOW_GROWTH_MODAL';
export const SHOW_VISITATION_MODAL = 'SHOW_VISITATION_MODAL';
export const SHOW_ACTIVITIES_MODAL = 'SHOW_ACTIVITIES_MODAL';
export const SHOW_BASIC_MODAL = 'SHOW_BASIC_MODAL';
export const SHOW_SLEEP_MODAL = 'SHOW_SLEEP_MODAL';
export const SHOW_UNSAVED_MODAL = 'SHOW_UNSAVED_MODAL';
export const SHOW_PREVIOUS_MODAL = 'SHOW_PREVIOUS_MODAL';
export const SET_SELECTED_BABY = 'SET_SELECTED_BABY';
export const SET_GROWTH_TYPE = 'SET_GROWTH_TYPE';
export const BABY_EDITOR_OPEN_MODAL = 'BABY_EDITOR_OPEN_MODAL';
export const BABY_EDITOR_CLOSE_MODAL = 'BABY_EDITOR_CLOSE_MODAL';
export const BABY_CREATE_OPEN_MODAL = 'BABY_CREATE_OPEN_MODAL';
export const SHOW_SAVE_ENTRY_MODAL = 'SHOW_SAVE_ENTRY_MODAL';
export const BABY_CREATE_CLOSE_MODAL = 'BABY_CREATE_CLOSE_MODAL';
export const SHOW_LOGOUT_WARNING_MODAL = 'SHOW_LOGOUT_WARNING_MODAL';
export const HIDE_LOGOUT_WARNING_MODAL = 'HIDE_LOGOUT_WARNING_MODAL';

export function menuOpen() {
  // TODO: see refactor note in components/NavigationDropdown/LearnNavigation.js
  document.body.classList.remove('navigation-dropdown--open');
  return {
    type: MENU_OPEN
  };
}

export function menuClose() {
  return {
    type: MENU_CLOSE
  };
}

export function showHeader() {
  return {
    type: SHOW_HEADER
  };
}

export function showUnSavedModal() {
  return {
    type: SHOW_UNSAVED_MODAL
  };
}

export function hideHeader() {
  return {
    type: HIDE_HEADER
  };
}

export function showFooter() {
  return {
    type: SHOW_FOOTER
  };
}

export function hideFooter() {
  return {
    type: HIDE_FOOTER
  };
}

export function showTrackerModal() {
  return {
    type: SHOW_GLOBAL_TRACKER_MODAL
  };
}

export function hideTrackerModals() {
  return {
    type: HIDE_MODALS
  };
}

export function showMilestoneModal() {
  return {
    type: SHOW_MILESTONE_MODAL
  };
}
export function showDietDiaperModal() {
  return {
    type: SHOW_DIET_DIAPER_MODAL
  };
}
export function showGrowthModal() {
  return {
    type: SHOW_GROWTH_MODAL
  };
}
export function showVisitationModal() {
  return {
    type: SHOW_VISITATION_MODAL
  };
}

export function showActivitiesModal() {
  return {
    type: SHOW_ACTIVITIES_MODAL
  };
}

export function showBasicModal() {
  return {
    type: SHOW_BASIC_MODAL
  };
}

export function showSleepModal() {
  return {
    type: SHOW_SLEEP_MODAL
  };
}

export function showSaveEntryModal() {
  return {
    type: SHOW_SAVE_ENTRY_MODAL
  }
}

export function showPreviousModal() {
  return {
    type: SHOW_PREVIOUS_MODAL
  };
}

export function setSelectedBaby(id) {
  return {
    type: SET_SELECTED_BABY,
    payload: id
  };
}

export function setGrowthType(growthType) {
  return {
    type: SET_GROWTH_TYPE,
    payload: growthType
  };
}

export function openBabyEditorModal(babyId) {
  return {
    type: BABY_EDITOR_OPEN_MODAL,
    babyId
  };
}

export function closeBabyEditorModal() {
  return {
    type: BABY_EDITOR_CLOSE_MODAL
  };
}

export function openBabyCreateModal() {
  return {
    type: BABY_CREATE_OPEN_MODAL
  };
}

export function closeBabyCreateModal() {
  return {
    type: BABY_CREATE_CLOSE_MODAL
  };
}



// WEBPACK FOOTER //
// ./src/actions/ui.js